/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="mc-form-carpool-recap">

    <RecapCarpool
    v-if="showRecap"
      ref="recap"
      :recap="recap"
    ></RecapCarpool>

    <div v-if="instance != 'sncf' && recap.driver" class="license-certification">
      {{$t('PostCarpool.legalInfos')}}
    </div>

    <div v-if="instance == 'sncf' && recap.driver">
      <br>
      <ion-item lines="none">
        <ion-checkbox
          name="hasLicense"
          :value="hasLicense"
          color="success"
          slot="start"
          @ionChange="hasLicense = ! hasLicense"
          :checked="hasLicense"
        ></ion-checkbox>
        <ion-label class="no-white-space"><p>{{ $t('PostCarpool.hasLicense') }}</p></ion-label>
      </ion-item>
      <div v-if="posted">
        <div class="mc-error-label"  v-if="!hasLicense">{{$t('Validation.required')}}</div>
      </div>
      <ion-item lines="none">
        <ion-checkbox
          name="hasContract"
          :value="hasContract"
          color="success"
          slot="start"
          @ionChange="hasContract = ! hasContract"
          :checked="hasContract"
        ></ion-checkbox>
        <ion-label class="no-white-space"><p>{{ $t('PostCarpool.hasContract') }}</p></ion-label>
      </ion-item>
      <div v-if="posted">
        <div class="mc-error-label"  v-if="!hasContract">{{$t('Validation.required')}}</div>
      </div>
      <ion-item lines="none">
        <ion-checkbox
          name="hasInsurance"
          :value="hasInsurance"
          color="success"
          slot="start"
          @ionChange="hasInsurance = ! hasInsurance"
          :checked="hasInsurance"
        ></ion-checkbox>
        <ion-label class="no-white-space"><p>{{ $t('PostCarpool.hasInsurance') }}</p></ion-label>
      </ion-item>
      <div v-if="posted">
        <div class="mc-error-label"  v-if="!hasInsurance">{{$t('Validation.required')}}</div>
      </div>
      <br>
      <a class="text-center pointer mt-10" v-if="instance == 'sncf'" v-on:click="goToSncfCharte()">Voir la charte</a>
      <br>
    </div>



  </div>
</template>

<style lang="scss">
  .license-certification {
    margin-top: 20px;
    margin-bottom: 30px;
  }
</style>

<script>

import RecapCarpool from "../Shared/Components/RecapCarpool.component";
import RecapCarpoolDTO from "../Shared/RecapCarpoolDTO";
import {toast} from "../../Shared/Mixin/toast.mixin";
import useVuelidate from "@vuelidate/core";

export default {
  name: "post-carpool-step7",
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      instance: process.env.VUE_APP_INSTANCE,
      showRecap: true,
      posted: false,
      hasLicense: false,
      hasContract: false,
      hasInsurance: false
    };
  },
  mixins: [toast],
  validations() {
    return {}
  },
  components: {
    RecapCarpool
  },
  mounted() {
    setTimeout(() => {
      // if (!!this.$refs.recap.$refs.mapRecap) this.$refs.recap.$refs.mapRecap.leafletObject.invalidateSize();
    }, 500);
  },
  created() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.currentSlider,
      (newValue, oldValue) => {
        if (oldValue != newValue && newValue == "post-carpool-step7") {
         this.showRecap = false;
          setTimeout(() => {
            this.showRecap = true;
          }, 1);
        }
      }
    );
  },
  beforeDestroy() {
    this.unwatch();
  },
  computed: {
    carpoolToPost() {
      return this.$store.getters.carpoolToPost;
    },

    priceCarpool() {
      return this.$store.getters.priceCarpool;
    },

    directPointsCarpool() {
      return this.$store.getters.directPointsCarpool.directPoints;
    },

    recap() {
      return new RecapCarpoolDTO().fromCarpoolToPost(
        this.carpoolToPost,
        this.$store.state.userStore.user,
        this.priceCarpool,
        this.directPointsCarpool
      )
    }
  },
  methods: {
    validate() {
      this.v$.$reset();
      this.v$.$touch();
      if (this.v$.$invalid || (this.instance == "sncf" && this.recap.driver && (!this.hasLicense || !this.hasContract || !this.hasInsurance))) {
        this.posted = true;
        if (this.instance == "sncf") {
          this.presentToast('Veuillez accepter les conditions en bas de page.', 'danger')
        }
        return false;
      } else {
        return true;
      }
    },

    displayStep(step) {
      let result = "";

      if (!!step.displayLabel) {
        result = `${step.displayLabel[0]},  ${step.displayLabel[1]}`;
      } else {
        result = `${step.addressLocality},  ${step.addressCountry}`;
      }
      return result;
    },
    goToSncfCharte() {
      window.open(this.$t("Link.charte"), '_blank');
    }
  }
};
</script>
